import cx from 'classnames';
import PropTypes from 'prop-types';

import CenterPageLayout from 'src/components/PageLayout';

import { useStyles } from './useStyles';

export const UnauthenticatedPageLayout = ({ className, children }) => {
  const styles = useStyles();

  return (
    <CenterPageLayout className={cx(styles.root, className)}>
      <div className={styles.background} />

      <div className={styles.content}>{children}</div>
    </CenterPageLayout>
  );
};

UnauthenticatedPageLayout.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

UnauthenticatedPageLayout.defaultProps = {
  className: null,
  children: null,
};
